import { Brand } from '@blade/std-lib'

export const WalletIdTypeId = 'tradebot-tma/WalletId'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type WalletIdTypeId = typeof WalletIdTypeId

export type WalletId = Brand.Branded<string, WalletIdTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WalletId = Brand.nominal<WalletId>()
